import { Colors, FlexBox } from "@brg/ui";
import styled from "styled-components";
import {LayoutConst} from "../../../../../core";


export const BookIcon = styled(FlexBox)`
    position: absolute;
    width: 40px;
    height: 40px;
    right: 0px;
    top: 0px;
    z-index: 1;

    box-shadow: -6px 7px 15px rgba(0, 0, 0, 0.22);

    background: linear-gradient(to bottom left, ${Colors.galBlack5} 50%, rgba(128, 128, 128, 0.6) 50%);
`;

export const BookIconRed = styled(FlexBox)`
    position: absolute;
    width: 12px;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 1;

    box-shadow: -1px 0px 1px 0px rgba(255, 0, 0, 0.7), 1px 0px 1px 0px rgba(255, 0, 0, 0.7);

    background: rgba(255, 0, 0, 1);
`;

export const BookIconRedMore = styled(FlexBox)`
    position: absolute;
    column-gap: 8px;
    left: 0;
    bottom: -15px;
    z-index: 1;
    width: 100%;
    justify-content: center;
  

  @media (max-width: ${LayoutConst.screen.m}px) {
    column-gap: 6px;
    bottom: -8px;
  }    
  
  @media (max-width: ${LayoutConst.screen.md}px) {
    position: relative;
    padding-top: 8px;
    bottom: auto;
  }  
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    column-gap: 6px;
  }
`;

export const BookIconRedMoreDot = styled(FlexBox)<{isBlue?: boolean}>`
    width: 6px;
    height: 6px;
    z-index: 1;

    background: ${({isBlue}) => isBlue ? '#609AF0' : 'rgba(255, 0, 0, 1)'};
    border-radius: 100%;
  
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 4px;
      height: 4px;
    }
`;import { Colors, FlexBox } from "@brg/ui";
import styled from "styled-components";
import {LayoutConst} from "../../../../../core";


export const BookIcon = styled(FlexBox)`
    position: absolute;
    width: 40px;
    height: 40px;
    right: 0px;
    top: 0px;
    z-index: 1;

    box-shadow: -6px 7px 15px rgba(0, 0, 0, 0.22);

    background: linear-gradient(to bottom left, ${Colors.galBlack5} 50%, rgba(128, 128, 128, 0.6) 50%);
`;

export const BookIconRed = styled(FlexBox)`
    position: absolute;
    width: 12px;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 1;

    box-shadow: -1px 0px 1px 0px rgba(255, 0, 0, 0.7), 1px 0px 1px 0px rgba(255, 0, 0, 0.7);

    background: rgba(255, 0, 0, 1);
`;

export const BookIconRedMore = styled(FlexBox)`
    position: absolute;
    column-gap: 8px;
    left: 0;
    bottom: -15px;
    z-index: 1;
    width: 100%;
    justify-content: center;
  

  @media (max-width: ${LayoutConst.screen.m}px) {
    column-gap: 6px;
    bottom: -8px;
  }    
  
  @media (max-width: ${LayoutConst.screen.md}px) {
    position: relative;
    padding-top: 8px;
    bottom: auto;
  }  
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    column-gap: 6px;
  }
`;

export const BookIconRedMoreDot = styled(FlexBox)<{isBlue?: boolean}>`
    width: 6px;
    height: 6px;
    z-index: 1;

    background: ${({isBlue}) => isBlue ? '#609AF0' : 'rgba(255, 0, 0, 1)'};
    border-radius: 100%;
  
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 4px;
      height: 4px;
    }
`;